import React from "react";
import {
  Save, Mail, Briefcase, Building2, ShieldCheck, IdCard,
} from "lucide-react";

const ROLES = [
  { v: "owner",      label: "Owner" },
  { v: "admin",      label: "Admin" },
  { v: "supervisor", label: "Supervisor" },
  { v: "employee",   label: "Employee" },
];

function Field({ label, icon: Icon, children }) {
  return (
    <div>
      <label className="text-[10px] font-bold uppercase tracking-[0.22em] text-white/60 mb-2 inline-flex items-center gap-1.5">
        <Icon className="w-3 h-3" strokeWidth={3} /> {label}
      </label>
      {children}
    </div>
  );
}

/** Editable identity form (name/role/company/job_title) + Save button. */
export default function DrawerEditForm({ user, form, setForm, isSelf, saving, companies, onSave }) {
  const inputBase = "w-full h-11 px-3 bg-white/5 border-2 text-white";
  return (
    <div className="px-5 py-5 space-y-5">
      <Field label="Email" icon={Mail}>
        <input
          value={user.email}
          disabled
          className="w-full h-11 px-3 bg-white/5 border-2 border-white/20 text-white/70 font-mono text-sm cursor-not-allowed"
        />
        <p className="text-[10px] uppercase tracking-wider text-white/40 mt-1">Immutable primary identifier</p>
      </Field>

      <Field label="Full Name" icon={IdCard}>
        <input
          data-testid="drawer-name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className={inputBase}
          style={{ borderColor: "#F9D71C" }}
        />
      </Field>

      <Field label="Role" icon={ShieldCheck}>
        <select
          data-testid="drawer-role"
          value={form.role}
          onChange={(e) => setForm({ ...form, role: e.target.value })}
          disabled={isSelf}
          className={`${inputBase} disabled:opacity-60 disabled:cursor-not-allowed`}
          style={{ borderColor: "#F9D71C" }}
        >
          {ROLES.map((r) => (
            <option key={r.v} value={r.v} className="bg-[#0B1E3F]">{r.label}</option>
          ))}
        </select>
        {isSelf && <p className="text-[10px] uppercase tracking-wider text-white/40 mt-1">You can&apos;t change your own role</p>}
      </Field>

      <Field label="Company" icon={Building2}>
        <select
          data-testid="drawer-company"
          value={form.company_id || ""}
          onChange={(e) => setForm({ ...form, company_id: e.target.value })}
          className={inputBase}
          style={{ borderColor: "#F9D71C" }}
        >
          <option value="" className="bg-[#0B1E3F]">— Personal (no company) —</option>
          {(companies || []).map((c) => (
            <option key={c.id} value={c.id} className="bg-[#0B1E3F]">{c.name}</option>
          ))}
        </select>
      </Field>

      <Field label="Job Title" icon={Briefcase}>
        <input
          data-testid="drawer-job-title"
          value={form.job_title || ""}
          onChange={(e) => setForm({ ...form, job_title: e.target.value })}
          placeholder="e.g. Site Foreman"
          className={`${inputBase} placeholder:text-white/30`}
          style={{ borderColor: "#F9D71C" }}
        />
      </Field>

      <button
        data-testid="drawer-save"
        onClick={onSave}
        disabled={saving}
        className="w-full h-12 inline-flex items-center justify-center gap-2 bg-safety-yellow text-black border-2 border-safety-yellow font-black uppercase tracking-wider hover:bg-safety-yellowHover transition-colors disabled:opacity-60"
      >
        <Save className="w-4 h-4" strokeWidth={3} />
        {saving ? "Saving…" : "Save Changes"}
      </button>
    </div>
  );
}
